// The pages below an environment, in one place: the scenario tests used to live under a route of their own, and
// every link to them was written out by hand.

export const environmentPath = (customerID?: string, environment?: string) =>
    `/dashboard/${customerID}/${environment}`;

export const scenarioTestsPath = (customerID?: string, environment?: string) =>
    `${environmentPath(customerID, environment)}/scenariotests`;

export const scenarioRunPath = (
    customerID?: string,
    environment?: string,
    runId?: string
) => `${scenarioTestsPath(customerID, environment)}/${runId}`;
